import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "../AppLayout";
import StandaloneHomePage from "./home/StandaloneHomePage";
import StandaloneLegalDocPage from "./legal/StandaloneLegalDocPage";
import { TactikAppShell } from "./app/TactikAppShell";
import TactikProductPage from "./app/TactikProductPage";
import StandaloneCheckoutPage from "./order/CheckoutPage";
import StandaloneOrderDetailPage from "./order/OrderDetailPage";
import StandaloneOrdersPage from "./order/StandaloneOrdersPage";
import StandaloneBenefitsPage from "./benefits/MyBenefitsPage";

/** Tactik 独立站路由 */
function StandaloneApp() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<StandaloneHomePage />} />
        <Route path="/follows" element={<Navigate to="/" replace />} />
        <Route path="/subscriptions" element={<Navigate to="/" replace />} />
        <Route path="/orders" element={<Navigate to="/tactik/orders" replace />} />
        <Route path="/legal/:slug" element={<StandaloneLegalDocPage />} />
        <Route path="/tactik/orders" element={<StandaloneOrdersPage />} />
        <Route path="/tactik/orders/:orderId" element={<StandaloneOrderDetailPage />} />
        <Route path="/tactik/benefits" element={<StandaloneBenefitsPage />} />
        <Route path="/tactik/checkout/:orderId" element={<StandaloneCheckoutPage />} />
        <Route path="/tactik" element={<TactikAppShell />}>
          <Route index element={<Navigate to="intel" replace />} />
          <Route path="my-notes" element={<Navigate to="/tactik/notes" replace />} />
          <Route path=":segment" element={<TactikProductPage />} />
        </Route>
        <Route path="/space/*" element={<Navigate to="/tactik/intel" replace />} />
        <Route path="/checkout/*" element={<Navigate to="/tactik/orders" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default StandaloneApp;
